// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import FormCheckBoxList from '../../../common/FormCheckBoxList';

export interface AddGroupMembershipProps {
  userProfileId?: string;
  allGroups?: unknown[];
  cancel: () => void;
  done: (ids?: unknown) => void;
  assignedGroups: unknown[];
}

function AddGroupMembership({ allGroups, done, cancel, assignedGroups }: AddGroupMembershipProps) {
  const { t } = useTranslation();
  const {
    register,
    control,
    getValues,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      id: assignedGroups.map((x) => x.id),
    },
  });

  const onSubmit = (data) => {
    if (data.id) {
      done(data.id);
      return;
    }
    toast.error(t('Please required fields'));
  };

  return (
    <SlideoutLayout
      title={t('Add membership')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          key="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <FormCheckBoxList
        label={t('Group')}
        required
        name="id"
        register={register}
        errorMessage={t('Required')}
        error={errors.id}
        getValues={getValues}
        setValue={setValue}
        control={control}
        items={
          allGroups &&
          [...allGroups]
            ?.sort((a, b) => a.name.localeCompare(b.name))
            .map((x) => ({ text: x.name, value: x.id }))
        }></FormCheckBoxList>
    </SlideoutLayout>
  );
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupMembership);
